import { render, staticRenderFns } from "./User.vue?vue&type=template&id=887a1e74&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=887a1e74&prod&lang=less"
import style1 from "./User.vue?vue&type=style&index=1&id=887a1e74&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887a1e74",
  null
  
)

export default component.exports